<template>
    <div class="page-header" :class="[{ 'page-header-fixed': path == '/' }, pageIndexClass]">
        <div class="page-header-content max-main">
            <div class="left">
                <router-link class="logo" to="/"><img :src="logoSrc" /></router-link>
                <ul class="page-header-menu">
                    <li :class="{ current: path == '/' }"><router-link to="/">首页</router-link></li>
                    <li :class="{ current: path.includes('manage') }"><router-link to="/manage">管理中心</router-link></li>
                    <li :class="{ current: path.includes('help') }"><router-link to="/help">帮助中心</router-link></li>
                </ul>
            </div>
            <div class="right">
                <div v-if="userInfo" class="nav-right fl">
                    <router-link to="/manage/message" class="message-icon">
                        <el-badge :is-dot="num > 0" class="item">
                            <i class="icon-msg"></i>
                        </el-badge>
                    </router-link>
                    <el-dropdown @command="handleCommand" placement="bottom">
                        <div class="el-dropdown-link">
                            <div class="user">
                                <el-avatar v-if="userImage" :src="userImage" :size="32"></el-avatar>
                                <div class="name">
                                    {{ displayName }}
                                    <span class="more" v-if="$store.state.userType == 3">企业账号</span>
                                </div>
                            </div>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-switch-button" command="logout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div v-else class="no-login fl">
                    <router-link to="/login">登录 / 注册</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import logo from '@/assets/img/logo-white.png';
import user from '@/assets/img/user.png';
export default {
    data() {
        return {
            path: this.$route.path,
            pageIndexClass: 'page-header-index',
            logoSrc: logo,
            user
        };
    },
    computed: {
        displayName() {
            const { userType, userInfo } = this.$store.state || {};
            if (userType == 1) return userInfo.cpName ? userInfo.cpName : `新艺术家${String(userInfo.id).slice(-5)}`;
            if (userType == 3) return userInfo.cpName;
            return '';
        },
        userImage() {
            const { cpLogo } = this.$store.state.userInfo || {};
            const { imageUrl } = this.$store.state.config || {};
            return imageUrl && cpLogo ? this.$utils.coverImg(cpLogo, 100, 100) : user;
        },
        userInfo() {
            return this.$store.state && this.$store.state.userInfo;
        },
        num() {
            return (this.$store.state && this.$store.state.msgNum) || 0;
        },
    },
    mounted() {
        if (this.path == '/') {
            window.addEventListener('scroll', () => {
                if (window.scrollY > 90) {
                    this.pageIndexClass = '';
                    // this.logoSrc = this.logo;
                } else {
                    this.pageIndexClass = 'page-header-index';
                    // this.logoSrc = this.logo1;
                }
            });
        }
    },
    methods: {
        handleCommand(command) {
            // 退出登录
            if (command === 'logout') {
                this.$request({
                    url: '/org/logout',
                    method: 'POST',
                }).then((res) => {
                    const { state, msg } = res.data;
                    if (state != 1) return this.$message.error(msg);
                    this.$store.commit('LOGOUT');
                    this.$router.push({ path: '/login' });
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.page-header {
    background: transparent;
    width: 100%;
    z-index: 9;
    height: 160px;
    background-color: $--color-base;
    transition: all;

    .page-header-content {
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .page-header-menu {
            display: flex;

            li {
                font-weight: 500;
                text-align: center;
                padding: 0 40px;

                a {
                    color: #fff;
                    display: block;
                    border-radius: 5px;
                    opacity: .5;
                }

                &.current {
                    a {
                        opacity: 1;
                    }
                }
            }
        }

        .left {
            display: flex;
            align-items: center;
        }

        .logo {
            height: 36px;
            display: block;
            margin-right: 160px;

            img {
                height: 36px;
            }
        }

        .nav-right {
            .el-dropdown {
                vertical-align: middle;
                color: #fff;
                padding: 8px 32px 8px 12px;
                text-align: right;

                .user {
                    display: flex;
                    text-align: left;
                    align-items: center;

                    .name {
                        line-height: 14px;
                    }

                    .more {
                        font-size: 10px;
                        line-height: 10px;
                        margin-top: 6px;
                        display: block;
                    }
                }

                &::after {
                    content: '';
                    width: 8px;
                    height: 5px;
                    background: url('~@/assets/img/icon-dwon.png') center no-repeat;
                    background-size: cover;
                    position: absolute;
                    top: 22px;
                    right: 10px;
                    z-index: -1;
                    transition: all;
                    transform: rotate(0deg);
                }
            }

            .el-avatar {
                vertical-align: middle;
                margin-right: 8px;
            }

            .message-icon {
                font-size: 24px;
                line-height: 24px;
                vertical-align: middle;
                margin-right: 40px;
                color: #fff;

                .el-badge {
                    vertical-align: middle;
                }
            }
        }

        .icon-msg {
            width: 16px;
            height: 18px;
            display: inline-block;
            background: url('~@/assets/img/icon_msg.svg') center no-repeat;
            background-size: cover;
            position: relative;
        }
    }

    //首页 header样式重置
    &.page-header-fixed {
        background: $--background-gradient-theme;
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 100;

        .page-header-content {
            .left {
                display: flex;
                align-items: center;
            }

            .logo {
                display: block;
                margin-right: 90px;

                img {
                    width: 114px;
                }
            }
        }

        .el-dropdown,
        a {
            color: #fff;
        }

        &.page-header-index {
            padding: 20px 60px;
            background: transparent;

            a {
                font-size: 16px;
                font-weight: 600;
                font-style: italic;
            }

            .logo {
                margin-right: 68px;
            }

            .page-header-content {
                justify-content: left;

                .page-header-menu {
                    position: relative;
                    padding-left: 88px;
                    padding-right: 84px;

                    &::before {
                        content: '';
                        position: absolute;
                        left: 0px;
                        height: 19px;
                        width: 1px;
                        background: #fff;
                        top: 2px;
                        transform: rotate(20deg);
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        right: 41px;
                        height: 19px;
                        width: 1px;
                        background: #fff;
                        top: 2px;
                        transform: rotate(20deg);
                    }

                    li {
                        &.current {
                            a {
                                color: #fff;

                                &::before {
                                    background-color: #fff;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
